import styled from "@emotion/styled";
import { text, surface, zIndex, fontSize, fontWeight, lineHeight, spacing } from "@atlas-int/tokens";

export const LegendLabel = styled.div`
  color: ${text.primary};
  font-weight: ${fontWeight.semibold};
  font-size: ${fontSize.base};
  text-transform: uppercase;
  text-align: right;
  line-height: ${lineHeight.compact};
  border-right: solid 1px ${text.primary};
  padding-right: ${spacing[4]};
  max-width: 4.75rem;
  background-color: ${surface.white};
  z-index: ${zIndex.legendItem};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-sizing: content-box;
  min-height: 50%;
`;

export const SmallLegendLabel = styled(LegendLabel)`
  font-size: ${fontSize.xs};
`;
